import type { SxProps, Theme } from "@mui/material";

export const autocompletePaperSx: SxProps<Theme> = {
  fontSize: "0.875rem",
  boxShadow: "0 1px 6px rgba(0,0,0,0.12)",
  borderRadius: "6px",
  border: "1px solid #e5e7eb",
  mt: "4px",
  "& .MuiAutocomplete-listbox": {
    maxHeight: 256,
    padding: 0,
  },
  "& .MuiAutocomplete-option": {
    fontSize: "0.875rem",
    color: "#1f2937",
    padding: "8px 16px",
    minHeight: "unset",
    '&[aria-selected="true"]': {
      backgroundColor: "#eff6ff",
      color: "#1d4ed8",
    },
    "&.Mui-focused, &:hover": {
      backgroundColor: "#f9fafb",
    },
    '&[aria-selected="true"].Mui-focused': {
      backgroundColor: "#eff6ff",
    },
  },
};

export const autocompleteTextFieldSx: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    fontSize: "0.875rem",
    borderRadius: "6px",
    backgroundColor: "#fff",
    "& fieldset": { borderColor: "#d1d5db" },
    "&:hover fieldset": { borderColor: "#d1d5db" },
    "&.Mui-focused fieldset": {
      borderColor: "#3b82f6",
      borderWidth: "2px",
    },
  },
  "& .MuiAutocomplete-endAdornment": { display: "none" },
};
